import React from 'react';
import styles from './itemCardLayout.module.scss';

type ItemCardLayoutProps = {
  title?: string | false;
  subtitle?: string | false | JSX.Element;
  className?: string;
  style?: any;
};

const ItemCardLayout: React.FC<ItemCardLayoutProps> = ({
  title = false,
  subtitle = false,
  children,
  className,
  style,
  ...props
}) => {
  return (
    <div
      className={`${styles.itemCardLayout} ${className ? className : ''}`}
      style={style}
      {...props}
    >
      {(title || subtitle) && (
        <div className={`${styles.titleAndOther} d-flex justify-content-between`}>
          <>
            <div className="title d-inline-flex align-items-center">
              <h5 className="mb-0 text-gray">{title}</h5>
            </div>
            {subtitle && <div className="others d-inline-flex">{subtitle}</div>}
          </>
        </div>
      )}
      <div className={styles.cardBody}>{children}</div>
    </div>
  );
};

export default ItemCardLayout;
